import {
	get,
	post,
	postDownload,
	postFile
} from './http'
//登陆
const login = (param) => post('seller/enterprise_publicity_manage_api.php', param)

//获取手机验证码
const getMobileCode = (param) => post('api.php', param)

//修改用户密码
const resetPass = (param) => post('seller/brand_center_pc_login_api.php', param)

//管理端首页数据
const homeData = (param) => post('seller/brand_center_pc_login_api.php', param)

//排名数据
const hotSaleRanking = (param) => post('seller/brand_pos_api.php', param)

//门店详情
const storeDetails = (param) => post('seller/brand_center_api.php', param)

//门店服务评分数据
const getScore = (param) => post('mobile/index.php?m=BrandCenter&a=store_score', param)

//店铺装修数据
const shopDecoration = (param) => post('seller/brand_pos_api.php', param)

//门店基本信息修改
const updateShopInfo = (param) => post('seller/brand_pos_api.php', param)

//订单销售金额
const order_money = (param) => post('seller/brand_center_pc_report_api.php', param)

//订单销售数量
const order_num = (param) => post('seller/brand_center_pc_report_api.php', param)

//在线访问量
const visit_num = (param) => post('seller/brand_center_pc_report_api.php', param)

//商品销售排名
const sale_rank = (param) => post('seller/brand_center_pc_report_api.php', param)

//报表-门店订单量排行榜
const order_num_ranking = (param) => post('seller/brand_center_pc_report_api.php', param)

//报表-门店访问量排行榜
const visit_ranking = (param) => post('seller/brand_center_pc_report_api.php', param)

//报表-门店销售额排行榜
const sales_volume_ranking = (param) => post('seller/brand_center_pc_report_api.php', param)

//报表-门店数据排行
const stores_data_ranking_list = (param) => post('seller/brand_center_pc_report_api.php', param)

//品牌装修—编辑/删除品牌动态
const operation_brand_dynamic = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修-分类图片上传
const category_photo_upload = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//销售额排名
const money_rank = (param) => post('seller/brand_center_api.php', param)

//访问量排名
const visit_rank = (param) => post('seller/brand_center_api.php', param)

//订单量排名
const order_rank = (param) => post('seller/brand_center_api.php', param)

// No1榜
const rank_no1 = (param) => post('seller/brand_center_api.php', param)

//订单-导出订单
const export_order = (param) => post('seller/brand_center_pc_order_api.php', param)

//下属分公司列表
const branch_company = (param) => post('seller/brand_center_api.php', param)

// 分公司门店列表
const shop_list = (param) => post('seller/brand_center_api.php', param)

//活动通告-通告列表
const noticeList = (param) => post('seller/brand_center_pc_notice_api.php', param)

//活动通告-添加通告
const addNotice = (param) => post('seller/brand_center_pc_notice_api.php', param)

//权限-系统权限列表
const brand_role_list = (param) => post('seller/brand_center_pc_common_api.php', param)

//权限-根据管理员id获取权限清单
const get_user_role_list = (param) => post('seller/brand_center_pc_common_api.php', param)

//权限-添加管理员
const add_admin_user = (param) => post('seller/brand_center_pc_role_api.php', param)

//权限-管理员列表
const admin_users_list = (param) => post('seller/brand_center_pc_role_api.php', param)

//权限-编辑管理员
const edit_admin_user = (param) => post('seller/brand_center_pc_role_api.php', param)

//订单-订单列表
const order_list = (param) => post('seller/brand_center_pc_order_api.php', param)

//系统消息获取(第二版)
const systemMessage = (param) => post('seller/shopping_center_api.php', param)

//店铺装修图片上传
const shopDecorationUpload = (param) => post('seller/brand_pos_api.php', param)

//品牌装修-品牌首页发布
const home_save = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌top广告信息
const home_get = (param) => post('api.php', param)

//品牌装修-banner连接商品列表
const category_del = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修-分类删除
const link_goods_list = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—品牌简介
const brand_introduce = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—品牌简介信息
const brand_introduce_info = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—新增品牌视频
const add_brand_video = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—品牌视频信息
const brand_video_info = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—添加品牌动态
const add_brand_dynamic = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—品牌动态列表
const brand_dynamic_list = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//店铺订单金额
const storeOrderAmount = (param) => post('mobile/index.php?m=BrandCenter&a=store_order_amount', param)

//订单-订单详情
const order_info = (param) => post('seller/brand_center_pc_order_api.php', param)
//收支明细
const accountDetailed = (param) => post('seller/brand_pos_api.php', param)

//在途中订单金额
const deliveredOrdersCount = (param) => post('seller/brand_pos_api.php', param)

//在途中订单金额
const goodsList = (param) => post('seller/brand_pos_api.php', param)

//获取用户信息
const getUserInfo = (param) => post('seller/brand_pos_api.php', param)

// 删除商品
const delGoods = (param) => post('shopping_pos_api.php', param)

//商品库出售中/仓库中的数量
const goodsCount = (param) => post('seller/shopping_pos_api.php', param)

//品牌仓库（list）含搜索功能
const brandWarehouse = (param) => post('seller/shopping_pos_api.php', param)

//品牌仓库批量操作
const addWarehouse = (param) => post('seller/shopping_pos_api.php', param)

//退货单列表
const returnList = (param) => post('seller/order_api.php', param)

//商品详情信息
const goodsInfo = (param) => post('seller/shopping_pos_api.php', param)

//快递模板列表
const transportList = (param) => post('seller/brand_pos_api.php', param)

//实名验证图片上传
const userRealPicture = (param) => post('seller/brand_pos_api.php', param)

//实名认证信息
const userRealInfo = (param) => post('seller/brand_pos_api.php', param)

//品牌装修—品牌动态图片上传
const upload_dynamic_pic = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修—获取品牌背景图
const get_brand_top_bg = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//实名验证申请
const userRealApply = (param) => post('seller/brand_pos_api.php', param)

//品牌装修-分类获取
const get_category = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//品牌装修-分类添加
const category_add = (param) => post('seller/brand_center_pc_renovation_api.php', param)

//订单列表
const orderList = (param) => post('seller/order_api.php', param)

//店铺营业状态修改
const banStore = (param) => post('seller/shopping_center_api.php', param)

//门店暂停营业
const storeBan = (param) => post('seller/brand_pos_api.php', param)

//添加管理员
const add_admin = (param) => post('seller/brand_center_api.php', param)
//品牌装修-商品分类发布
const goods_class_save = (param) => post('seller/brand_center_pc_renovation_api.php', param)
//权限-设置管理员允许登录
const save_allow_login = (param) => post('seller/brand_center_pc_role_api.php', param)

//权限-删除管理员
const del_admin_users = (param) => post('seller/brand_center_pc_role_api.php', param)

//编辑管理员
const edit_admin = (param) => post('seller/brand_center_api.php', param)

//管理员列表
const admin_list = (param) => post('seller/brand_center_api.php', param)

//首页—门店分布&&品牌动态
const distribution_dynamic = (param) => post('seller/brand_center_pc_login_api.php', param)
//品牌装修—品牌动态信息
const brand_dynamic_info = (param) => post('seller/brand_center_pc_renovation_api.php', param)

// 分销商省分公司列表
const company_list = (param) => post('seller/brand_center_pc_agent_api.php', param)
// 分销商列表导出
const agentListExport = (param) => postDownload('seller/brand_center_pc_agent_api.php', param)
// 获取省份信息
const getProvince = () => post('mobile/index.php?m=flow&a=get_province')
// 获取城市信息
const getCity = (param) => post('mobile/index.php?m=flow&a=get_city',param)
// 获取县信息
const getArea = (param) => post('mobile/index.php?m=flow&a=get_area',param)
// 图片临时存储
const uploadPicture = (param) => post('seller/brand_center_pc_login_api.php',param)
// 编辑/添加分销商
const editDistributors = (param) => post('seller/brand_center_pc_agent_api.php',param)
// 获取店铺展示信息
const getShopmessage = (param) => post('mobile/index.php?m=store&a=get_store_home',param)
// 获取推荐商品
const getStorebestgoods = (param) => post('mobile/index.php?m=store&a=get_store_best_goods',param)
// 商品库接口
// 商品库商品列表
const goods_list = (param) => post('seller/brand_center_pc_goods_api.php',param)
//品牌装修—品牌视频列表
const brand_video_list = (param) => post('seller/brand_center_pc_renovation_api.php',param)

//品牌装修—删除品牌视频
const del_brand_video = (param) => post('seller/brand_center_pc_renovation_api.php',param)

//企业装修--企业介绍发布(新版)
const enterprise_introduction_release2 = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业介绍背景图获取
const get_enterprise_introduction_backdrop = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业首页—企业介绍（包含头部背景图）
const business_intro = (param) => post('seller/enterprise_publicity_api.php',param)

//企业首页—企业动态
const business_dynamic = (param) => post('seller/enterprise_publicity_api.php',param)

//企业资料--文件目录列表
const file_cata_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业资料--文件目录新增
const file_cata_add = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业资料--文件目录设置密码
const file_cata_pass_save = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业资料--文件目录删除
const file_cata_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业资料--文件列表
const get_enterprise_file_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业合作--公司基本信息发布
const enterprise_info_release = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业合作—电话地址信息
const business_cooperation = (param) => post('seller/enterprise_publicity_api.php',param)

//员工名片--名片列表
const staff_card_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--下载批量导入模板
const down_import_template = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--待录入员工名片列表
const batch_import_card_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--待录入员工名片删除（支持批量）
const batch_import_card_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--名片样式列表
const get_card_style_type = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--待录入员工名片立即录入操作
const batch_import_card_insert = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--待录入员工名片立即录入操作
const staff_card_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--设置启用/禁用（支持批量）
const staff_card_show = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--添加员工名片
const staff_card_add = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//员工名片--员工名片详情
const staff_card_info = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业动态文章添加(新版)
const enterprise_add_doc2 = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业动态文章列表获取
const get_enterprise_dynamic_list = (param) => post('seller/enterprise_publicity_api.php',param)

//企业装修--企业动态信息删除
const del_enterprise_dynamic = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业动态视频添加
const enterprise_add_video = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//公司基本信息获取
const get_company_info = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//留言列表
const leave_message_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//删除留言
const leave_message_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//门店logo上传
const upload_store_logo = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业首页—企业商品
const business_goods_list = (param) => post('seller/enterprise_publicity_api.php',param)

//我的合作伙伴
const my_partnerse_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//添加分公司
const add_branch_office = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//分公司列表
const branch_office_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//分公司删除（支持批量）
const branch_office_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//公司logo模板列表
const img_template = (param) => post('seller/brand_pos_api.php',param)

//公司logo生成(由模板生成)
const img_compose = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//站内通知信息列表
const enterprise_msg_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--合作方式类型获取
const product_work_type = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--选择产品
const enterprise_goods_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--新增发布
const product_publish = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--已发布信息列表
const product_publish_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--已发布信息删除
const product_publish_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//申请合作伙伴请求列表
const be_agreed_partnerse = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//邀请入驻短信发送记录
const invite_msg_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//邀请入驻短信发送
const send_invite_msg = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//申请成为合作伙伴
const partnerse_apply = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//申请合作伙伴请求拒绝
const agreed_partnerse_refuse = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//合作伙伴信息设置隐藏/显示
const partnerse_set_hide = (param) => post('seller/enterprise_publicity_manage_api.php',param)

const staff_card_logo_uploads = (param,formDate) => postFile('seller/enterprise_publicity_manage_api.php',param,formDate)

//员工名片--发布前清空临时数据
const staff_card_publish_empty = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--合作方式类型新增
const product_work_type_add = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//信息发布--合作方式类型删除（支持批量）
const product_work_type_del = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//行业分类列表
const business_category_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业背景图模板列表
const enterprise_background_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//入驻前的信息检索
const before_entry_apply = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//添加区/县信息
const add_region_info = (param) => post('mobile/index.php?m=flow&a=add_region_info',param)

//企业产品--排序设置
const enterprise_goods_sort_set = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业介绍模板列表
const enterprise_introduction_tpl = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业装修--企业介绍图模板列表
const enterprise_introduce_tpl_list = (param) => post('seller/enterprise_publicity_manage_api.php',param)

//企业产品--产品/服务分类详情
const enterprise_goods_cat_info = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//员工名片--批量设置产品显示方式
const staff_card_set_product_show = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//行业分类添加
const add_business_category = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//商协会-文章列表
const wzlist = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//sss
const get_fcib_use_module = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//商协会-商协会所有功能模板获取
const get_fcib_all_module = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//商协会-开放功能设置
const get_fcib_module_set = (param) => post('seller/enterprise_publicity_manage_api.php',param)
//修改账号
const login_mobile_modify = (param) => post('seller/enterprise_publicity_manage_api.php',param)
export default {
	login,
	homeData,
	wzlist,
	get_fcib_use_module,
	get_fcib_all_module,
	get_fcib_module_set,
	login_mobile_modify,
	order_list,
	add_region_info,
	staff_card_set_product_show,
	enterprise_introduction_tpl,
	add_business_category,
	enterprise_introduce_tpl_list,
	enterprise_goods_cat_info,
	enterprise_goods_sort_set,
	product_work_type_add,
	product_work_type_del,
	business_category_list,
	enterprise_background_list,
	staff_card_logo_uploads,
	before_entry_apply,
	export_order,
	staff_card_publish_empty,
	hotSaleRanking,
	img_template,
	partnerse_set_hide,
	agreed_partnerse_refuse,
	product_publish,
	invite_msg_list,
	send_invite_msg,
	partnerse_apply,
	enterprise_goods_list,
	img_compose,
	product_publish_del,
	product_publish_list,
	be_agreed_partnerse,
	product_work_type,
	branch_office_del,
	business_goods_list,
	my_partnerse_list,
	add_branch_office,
	getScore,
	enterprise_msg_list,
	edit_admin_user,
	shopDecoration,
	updateShopInfo,
	branch_office_list,
	storeDetails,
	leave_message_del,
	upload_store_logo,
	order_num,
	business_intro,
	business_dynamic,
	leave_message_list,
	file_cata_list,
	link_goods_list,
	order_money,
	visit_num,
	systemMessage,
	getMobileCode,
	resetPass,
	home_save,
	order_info,
	home_get,
	brand_introduce,
	brand_introduce_info,
	add_brand_video,
	category_del,
	get_category,
	add_brand_dynamic,
	brand_dynamic_info,
	brand_dynamic_list,
	get_user_role_list,
	shopDecorationUpload,
	storeOrderAmount,
	accountDetailed,
	deliveredOrdersCount,
	goodsList,
	goods_class_save,
	getUserInfo,
	delGoods,
	brand_video_info,
	goodsCount,
	category_photo_upload,
	upload_dynamic_pic,
	brandWarehouse,
	addWarehouse,
	returnList,
	goodsInfo,
	userRealPicture,
	userRealInfo,
	userRealApply,
	orderList,
	storeBan,
	sale_rank,
	money_rank,
	visit_rank,
	order_rank,
	rank_no1,
	branch_company,
	shop_list,
	operation_brand_dynamic,
	add_admin,
	del_admin_users,
	edit_admin,
	admin_list,
	distribution_dynamic,
	get_brand_top_bg,
	company_list,
	agentListExport,
	order_num_ranking,
	visit_ranking,
	sales_volume_ranking,
	stores_data_ranking_list,
	addNotice,
	noticeList,
	getProvince,
	getCity,
	getArea,
	brand_role_list,
	add_admin_user,
	admin_users_list,
	save_allow_login,
	uploadPicture,
	editDistributors,
	goods_list,
	category_add,
	getShopmessage,
	getStorebestgoods,
	brand_video_list,
	del_brand_video,
	enterprise_introduction_release2,
	get_enterprise_introduction_backdrop,
	file_cata_add,
	file_cata_pass_save,
	file_cata_del,
	get_enterprise_file_list,
	enterprise_info_release,
	business_cooperation,
	staff_card_list,
	down_import_template,
	batch_import_card_list,
	batch_import_card_del,
	get_card_style_type,
	batch_import_card_insert,
	staff_card_del,
	staff_card_show,
	staff_card_add,
	staff_card_info,
	enterprise_add_doc2,
	get_enterprise_dynamic_list,
	del_enterprise_dynamic,
	enterprise_add_video,
	get_company_info
}
